import React, { useState, useEffect, Fragment } from "react";
import { login } from "../db";
import { useStateValue } from "../store/provider";
import { LOGIN } from "../store/reducer";

import { db } from "../firebase/firebase";

import axios from "axios";

import "./Login.css";

const Login = (props) => {
  const [data, setData] = useState([]);
  const [haskeyError, setHasKeyError] = useState(false);
  const [hasAdmin, setHasAdmin] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    key: "",
    package: "",
    haskeyError: "",
  });
  const [hasError, setHasError] = useState(false);

  // const [errors, setError] = useState({
  //   key: "",
  //   package: "",
  // });

  const [, dispatch] = useStateValue();

  const handleInputChange = (ev) => {
    setFormData({
      ...formData,
      [ev.target.name]: ev.target.value,
    });
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    const data_ = {
      key: formData.key,
      package: formData.package,
    };

    if (formData.key && formData.package) {
      debugger;
      console.log(data_);
      await axios
        .post("/clientpackagechk", data_)
        .then(async (res) => {
          debugger;
          // console.log(res.data.message);
          const data = await login(formData);
          setHasKeyError(false);

          if (data.hasError) {
            return setHasError(true);
          }
          return dispatch({
            type: LOGIN,
            payload: data.admin,
          });
        })
        .catch((error) => {
          debugger;
          console.log(error);
          return setHasKeyError(true);
        });
    } else {
      const data = await login(formData);

      if (data.hasError) {
        return setHasError(true);
      }
      return dispatch({
        type: LOGIN,
        payload: data.admin,
      });
    }
  };

  useEffect(() => {
    axios
      .get("/client")
      .then((res) => {
        // console.log(res.data.data, res.data.data._id);
        // setId(...res.data.data._id);
        setData(res.data.data);
      })
      .catch((error) => console.log(error));
  }, []);
  useEffect(async () => {
    const adminRef = db.collection("admins");

    const sizeOfCollection = await (await adminRef.get()).size;

    if (sizeOfCollection === 0) {
      debugger;
      return setHasAdmin(true);
    }

    // if (formData.email) {
    const adminData = await adminRef
      .where("email", "==", formData.email)
      .where("password", "==", formData.password)
      .get();
    let admin;
    adminData.forEach((item) => {
      admin = { ...item.data(), id: item.id };
    });
    // console.log(admin);

    if (admin && admin.flag === true) {
      if (admin.key !== "" && admin.package !== "") {
        setHasAdmin(false);
      } else {
        setHasAdmin(true);
      }
    }
    // }
  }, [formData.email, formData.password]);

  return (
    <div className="body">
      <div className="login-container">
        <div className="login-container-img">
          <h1>
            Welcome to
            <span>App Browser</span>
          </h1>
        </div>
        <div className="login-container-content">
          <form onSubmit={handleSubmit} className="login-form">
            <h1>Login</h1>
            <p className="field">
              <label>Email</label>
              <input
                type="text"
                name="email"
                onChange={handleInputChange}
                placeholder="Email"
                required
              />
            </p>
            <p className="field">
              <label>Password</label>
              <input
                type="password"
                name="password"
                onChange={handleInputChange}
                placeholder="Password"
                required
              />
            </p>
            {/* {data.map((data) => {
              // id = data._id;
              if (data.package === "" || data.package === null) {
                return ( */}

            {hasAdmin && (
              <Fragment>
                <p className="field">
                  <label>Key</label>
                  <input
                    type="password"
                    name="key"
                    onChange={handleInputChange}
                    placeholder="Key"
                    required
                  />
                </p>
                <p className="field">
                  <label>Package Name</label>
                  <input
                    type="text"
                    name="package"
                    onChange={handleInputChange}
                    placeholder="Package Name"
                    required
                  />
                  <input
                    type="hidden"
                    name="_id"
                    value={data._id}
                    onChange={handleInputChange}
                  />
                </p>
              </Fragment>
            )}
            {/* );
              }
            })} */}

            {haskeyError && (
              <p style={{ color: "red" }}>Incorrect !! Key Or Package !!</p>
            )}
            {hasError && (
              <p style={{ color: "red" }}>
                Incorrect Credential !! Try Again !!
              </p>
            )}
            <button type="submit" className="submitBtn">
              Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Login);
